import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'nwt-power-supply-validation-error-dialog',
  template:
    `
  <h1 mat-dialog-title>{{message}}</h1>
  <mat-dialog-actions class="d-flex justify-content-center">
  <button mat-button type="button" (click)="onClick('ok')">OK</button>
  </mat-dialog-actions>
  `
})
export class ValidationErrorDialog implements OnInit {

  message: string = '';
  constructor(
    public dialogRef: MatDialogRef<ValidationErrorDialog>,
    @Inject(MAT_DIALOG_DATA) private data) {
      this.message = this.data.message;
  }

  ngOnInit() {
  }

  onClick(value: string) {
    if (value === 'ok') {
      this.dialogRef.close('OK')
    }
  }
}
